import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { FormControl, FormHelperText, FormLabel, Stack } from "@mui/material";
import { EditorToolbar, EditorV2 } from "@styleguide";
import { Controller, type FieldValues, type Path, type PathValue } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export const FormGenInputRichText = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
  multiple,
}: IFormGenInputProps<Schema, T>) => {
  if (multiple) {
    throw new Error("Multiple rich text input is not supported");
  }

  return (
    <Controller
      control={control}
      name={uiSchemaElement.scope as unknown as Path<T>}
      defaultValue={"" as PathValue<T, Path<T>>}
      render={({ field, fieldState }) => (
        <FormControl error={Boolean(fieldState.error)} fullWidth>
          <Stack spacing={0.5}>
            <FormLabel>{uiSchemaElement.label}</FormLabel>
            <EditorV2
              id={`formgen-richtext-${field.name}`}
              value={field.value ?? ""}
              onChange={(html) => field.onChange(html)}
              toolbar={EditorToolbar.EDITORV2}
              excludePlugins={["autoresize"]}
              init={{ width: "100%", ...(uiSchemaElement.height !== undefined && { height: uiSchemaElement.height }) }}
            />
            {fieldState.error?.message && <FormHelperText>{fieldState.error.message}</FormHelperText>}
          </Stack>
        </FormControl>
      )}
    />
  );
};
